export default __webpack_public_path__ + "static/media/video-horizontal-background-0006.a75c1db0.jpg";